<template>
  <div id="configuratore">
    <div class="loader-mask-config" v-bind:class="{'hidden': !loaderOn}">
      <!-- Contenitore necessario per il loader che pulsa -->
      <div class="loader-config" v-bind:class="{'hidden': !loaderOn}">
        <div></div>
        <div></div>
      </div>

      <div class="percentage-upload">
        Upload modello {{progressUpdate}} %
      </div>
    </div>

    <div v-if="!uploadCompleted" class="clearfix" id="container-selector-file">
      <vue-clip v-show="uploader && !loaderOn" :options="options" class="uploader col-xs-12 noPadding"
                :on-sending="sending"
                :on-complete="uploadComplete"
                :on-total-progress="totalProgress"
                :key="keyClip">
        <template slot="clip-uploader-action">
          <div class="uploader-action col-xs-8 col-xs-offset-2">
            <div class="dz-message noselect"><h3 class="label-upload"> Clicca o trascina qui per caricare file formato
              STL </h3></div>
          </div>
        </template>
      </vue-clip>
    </div>
    <div class="clearfix" id="container-config-file" v-else>
      <div id="viewer" class="col-xs-8 clearfix">
        <model-stl :src="urlBase + '/api/v1/download/' + productData.id_stl"
                   :height="395"
                   :gammaOutput="true"
                   v-on:on-load="functionLoad"
                   v-on:on-progress="functionProgress"
                   v-on:on-error="functionError"
        ></model-stl>
      </div>
      <div class="loader-mask-config loader-render-model col-xs-8" v-show="percentageStlComponent !== 100">
        <!-- Contenitore necessario per il loader che pulsa -->
        <div class="loader-config">
          <div></div>
          <div></div>
        </div>

        <div class="percentage-stl-component">
          Rendering modello {{percentageStlComponent}} %
        </div>
      </div>

      <div id="option-menu" class="col-xs-4 clearfix">
        <div class="col-xs-12 noPadding item-to-select">
          <div class="col-xs-5 text-item-to-select">
            <span class="filters-label">Stampante</span>
            <a :href="getLinkFromCode()" target="_blank" class="dettaglio">
              <icon name="elm-info"></icon>
            </a>
          </div>
          <select class="col-xs-7 text-row" v-model="printers.selected" @change="onChange($event)">
            <option v-for="printer in printers.items" :value="printer.ID">{{printer.Title}}</option>
          </select>
        </div>

        <div class="col-xs-12 noPadding item-to-select" v-if="printers.selected !== ''">
          <div class="col-xs-5 text-item-to-select">
            <span class="filters-label">Materiale</span>
            <a v-if="materials.items.length > 0" :href="getMaterialLinkFromCode()" target="_blank" class="dettaglio">
              <icon name="elm-info"></icon>
            </a>
          </div>
          <select class="col-xs-7 text-row" v-model="materials.selected">
            <option v-for="material in materials.items" :value="material.ID">{{material.Title}}</option>
          </select>
        </div>

        <div class="col-xs-12 noPadding item-to-select">
          <div class="col-xs-5 text-item-to-select">
            <span class="filters-label">Finitura</span>
            <a v-if="postProcesses.items.length > 0 && getPostProcessLinkFromCode()" :href="getPostProcessLinkFromCode()" target="_blank" class="dettaglio">
              <icon name="elm-info"></icon>
            </a>
          </div>
          <select class="col-xs-7 noPadding text-row" v-model="postProcesses.selected">
            <option v-for="postProcess in postProcesses.items" :value="postProcess.ID">{{postProcess.Title}}</option>
          </select>
        </div>

        <div class="col-xs-12 noPadding item-to-select">
          <div class="col-xs-5 text-item-to-select">
            <span class="filters-label">Quantit&agrave;</span>
          </div>
          <div class="col-xs-7 noPadding text-row">
            <input type="number" name="quantity" min="1" v-model="quantity">
          </div>
        </div>

        <div
          v-if="!productData.width && !productData.height && !productData.volume && !productData.triangle_count"
          id="loader-detail-prd" class="col-xs-12 noPadding loader-mask-config">
          <div class="loader-config">
            <div></div>
            <div></div>
          </div>
        </div>

        <div v-else id="container-detail-prd">
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select">File</div>
            <div class="col-xs-7 noPadding file-name">{{productData.file_name}}</div>
          </div>
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select">Larghezza</div>
            <div class="col-xs-7 noPadding">{{productData.width}} mm</div>
          </div>
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select">Altezza</div>
            <div class="col-xs-7 noPadding">{{productData.height}} mm</div>
          </div>
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select">Profondit&agrave;</div>
            <div class="col-xs-7 noPadding">{{productData.depth}} mm</div>
          </div>
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select">Volume</div>
            <div class="col-xs-7 noPadding">{{productData.volume}} mm<SUP>3</SUP></div>
          </div>
          <div class="col-xs-12 noPadding item-to-select">
            <div class="col-xs-5 noPadding text-item-to-select text-item-to-select">Triangoli</div>
            <div class="col-xs-7 noPadding">{{productData.triangle_count}}</div>
          </div>
        </div>


        <div id="choose" class="col-xs-12 noPadding"
             v-if="productData.width && productData.height && productData.volume && productData.triangle_count">
          <button
            v-if="printers.items.length > 0 && materials.items.length > 0 && postProcesses.items.length > 0"
            class="btn btn-md btn-stroke btn-row col-xs-12 col-sm-7 noPadding button-blu-effect"
            v-on:click="addComponent">
            {{textConfirmButton}}
          </button>

          <button
            v-bind:class="[{'col-sm-offset-7': printers.items.length === 0 || materials.items.length === 0 || postProcesses.items.length === 0}, {'col-sm-offset-1': printers.items.length > 0 && materials.items.length > 0 && postProcesses.items.length > 0}]"
            class="btn btn-md btn-white-stroke btn-row col-xs-12 col-sm-4 noPadding button-yellow-effect"
            v-on:click="refreshConfigurator">Annulla
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  import {ModelStl} from 'vue-3d-model'
  import {progressbar} from 'vue-strap'
  import Bus from '@/components/Bus.js'
  import {validatorMixin} from '../mixins/validatorMixin'

  const axios = require('axios')

  export default {
    components: {
      swal,
      ModelStl,
      progressbar,
      Bus
    },
    name: 'configuratore-new',
    mixins: [validatorMixin],
    props: {
      refresh: {type: Boolean}
    },
    data () {
      return {
        textConfirmButton: 'Aggiungi a carrello',
        loaderOn: false,
        loaderProductDetail: true,
        uploader: true,
        // urlBase: process.env.HOST,
        urlBase: 'https://apiconfiguratore3d.elmec.com',
        options: {
          url: 'https://apiconfiguratore3d.elmec.com/api/v1/carts/stl',
          // url: process.env.HOST + '/api/v1/carts/stl',
          paramName: 'file',
          maxFilesize: 100,
          maxFiles: 1,
          accepttedFiles: [
            'application/sla',
            'application/vnd.ms-pki.stl',
            'application/x-navistyle'
          ]
        },
        uploadCompleted: false,
        printers: {
          selected: '',
          items: [],
          lastAdded: null
        },
        materials: {
          selected: '',
          items: [],
          lastAdded: null
        },
        postProcesses: {
          selected: '',
          items: [],
          lastAdded: null
        },
        quantity: 1,
        productData: {
          file_name: '',
          id_stl: ''
        },
        progressUpdate: 0,
        statusProduct: 404,
        percentageStlComponent: 0,
        keyClip: 0,
        refreshIntervalId: ''
      }
    },
    mounted: function () {
      this.getPrinters()
      this.getPostProcesses()

      Bus.$on('update_product', val => {
        this.uploadCompleted = true
        this.printers.selected = val.printer
        this.getMaterial(val.printer, () => {
          this.materials.selected = val.material
        })
        this.materials.selected = val.material
        this.postProcesses.selected = val.post_process
        this.quantity = val.quantity
        this.productData = val
        this.textConfirmButton = 'Aggiorna prodotto'
      })
    },
    methods: {
      uploadComplete: function (file, status, xhr) {
        if (status === 'success') {
          let resp = JSON.parse(xhr.response)
          this.productData.id_stl = resp.result.id_stl
          this.loaderOn = false
          this.uploadCompleted = true
          this.quantity = 1
          this.refreshIntervalId = setInterval(this.checkProductData, 1000)
          this.$emit('idstl', this.productData.id_stl)
          this.getMaterial(this.printers.selected)
        } else {
          this.loaderOn = false
          this.keyClip++
          swal('Errore', 'Si è verificato un errore con il caricamento del file!', 'error')
        }
      },
      sending: function (file, XHR, formData) {
        this.productData.file_name = file.name
        this.loaderOn = true
      },
      getPrinters: function () {
        axios.get('/api/v1/technology')
          .then((response) => {
            if (response.status === 200) {
              this.printers.items = response.data.result
              if (response.data.result.length > 0) {
                this.printers.selected = response.data.result[0].ID
                this.getMaterial(this.printers.selected)
              }
            }
          })
      },
      onChange: function (event) {
        this.getMaterial(event.target.value)
      },
      getMaterial: function (idPrinter, cb) {
        this.materials.items = []
        axios.get('/api/v1/technology/' + idPrinter + '/material')
          .then((response) => {
            if (response.status === 200 && response.data.result !== null) {
              this.materials.items = response.data.result

              // This filter is used to allow the following behaviour:
              // If the printer is changed > materials are changed
              // When I am uploading a new file, printers, materials and post process are set to the ones set for the previous uploaded file
              // If the previous materials selected does not belong to the current printer's material, we set the default one
              let matchMaterial = this.materials.items.filter(m => {
                return m.ID == this.materials.lastAdded
              })

              if (matchMaterial.length === 0 && response.data.result.length > 0) {
                this.materials.selected = response.data.result[0].ID
              }

              if (cb) cb()
            }
          })
      },
      getPostProcesses: function () {
        axios.get('/api/v1/post-process')
          .then((response) => {
            if (response.status === 200) {
              this.postProcesses.items = response.data.result
              if (response.data.result.length > 0) {
                this.postProcesses.selected = response.data.result[0].ID
              }
            }
          })
      },
      totalProgress (progress, totalBytes, bytesSent) {
        this.progressUpdate = parseInt(progress)
      },
      checkProductData: function () {
        axios.get('/api/v1/carts/products/' + this.productData.id_stl)
          .then(response => {
            this.statusProduct = response.status
            this.productData = response.data.result
            clearInterval(this.refreshIntervalId)
          })
      },
      addComponent: function () {
        let id_cart = localStorage.getItem('id_cart')
        let params

        if (!(this.isInteger(this.quantity))) {
          swal('Errore', 'Quantità selezionata non valida!', 'error')
          return
        }

        if (id_cart !== undefined && id_cart !== null && id_cart !== '') {
          params = {
            'id_cart': id_cart,
            'id_stl': this.productData.id_stl,
            'printer': parseInt(this.printers.selected),
            'material': parseInt(this.materials.selected),
            'post_process': parseInt(this.postProcesses.selected),
            'quantity': this.quantity.toString() !== '' && this.quantity > 0 ? this.quantity : 1,
            'check_file': this.productData.check_file
          }
        } else {
          params = {
            'id_stl': this.productData.id_stl,
            'printer': parseInt(this.printers.selected),
            'material': parseInt(this.materials.selected),
            'post_process': parseInt(this.postProcesses.selected),
            'quantity': this.quantity.toString() !== '' && this.quantity > 0 ? this.quantity : 1,
            'check_file': this.productData.check_file
          }
        }

        this.printers.lastAdded = parseInt(this.printers.selected)
        this.materials.lastAdded = parseInt(this.materials.selected)
        this.postProcesses.lastAdded = parseInt(this.postProcesses.selected)

        if (this.productData.id_stl && this.productData.id_stl !== '') {
          axios.post('/api/v1/carts/products/', params)
            .then((response) => {
              if (response.status === 201) {
                if (response.data.result.id_cart !== undefined && response.data.result.id_cart !== '') {
                  localStorage.setItem('id_cart', response.data.result.id_cart)
                  this.initDataConfigurator()
                  Bus.$emit('upload-complete')
                }
              }
            })
            .catch(() => {
              swal('Errore recupero informazioni', 'Prova a ricaricare la pagina. In caso di problemi contattati', 'error')
            })
        } else {
          swal('Errore', 'Si prega di selezionare un modello!', 'error')
        }
      },
      refreshConfigurator: function () {
        this.initDataConfigurator()
        this.$emit('clear-configurator')
      },
      initDataConfigurator: function () {
        this.textConfirmButton = 'Aggiungi a carrello'
        this.uploadCompleted = false

        if (this.printers.lastAdded !== null) {
          this.printers.selected = this.printers.lastAdded
        } else if (this.printers.items.length > 0) {
          this.printers.selected = this.printers.items[0].ID
        }

        if (this.materials.lastAdded !== null) {
          this.materials.selected = this.materials.lastAdded
        } else if (this.materials.items.length > 0) {
          this.materials.selected = this.materials.items[0].ID
        }

        if (this.postProcesses.lastAdded !== null) {
          this.postProcesses.selected = this.postProcesses.lastAdded
        } else if (this.postProcesses.items.length > 0) {
          this.postProcesses.selected = this.postProcesses.items[0].ID
        }

        this.quantity = 1
        this.productData = {
          file_name: '',
          id_stl: ''
        }
        this.progressUpdate = 0
        this.statusProduct = 404
      },
      functionLoad: function () {
        this.percentageStlComponent = 100
      },
      functionProgress: function (val) {
        this.percentageStlComponent = parseInt((val.loaded / val.total) * 100)
      },
      functionError: function (val) {
        swal('Errore', 'Si è verificato un errore con il render del file!', 'error')
      },
      getTextFromArray: function (warning) {
        let arrErr = JSON.parse(warning.replace(/'/g, '"'))
        let strErrs = ''

        arrErr.forEach(e => {
          strErrs += e.Message + ' '
        })

        return strErrs
      },
      getLinkFromCode: function () {
        let link = ''

        for (let i = 0; i < this.printers.items.length; i++) {
          if (this.printers.items[i].ID === this.printers.selected.toString()) {
            link = this.printers.items[i].LinkDetail
            break
          }
        }

        return link
      },
      getMaterialLinkFromCode: function () {
        let link = ''

        for (let i = 0; i < this.materials.items.length; i++) {
          if (this.materials.items[i].ID === this.materials.selected.toString()) {
            if (this.materials.items[i].Title === 'PA12') {
              link = 'https://www.elmec.com/3d/risorse/documenti/materiali/pa12.pdf'
            } else if (this.materials.items[i].Title === 'PA12 CB' || this.materials.items[i].Title === 'PA 12 CB' || this.materials.items[i].Title === 'PA12CB') {
              link = 'https://www.elmec.com/3d/risorse/documenti/materiali/pa12_cb.pdf'
            } else if (this.materials.items[i].Title.toLowerCase() === 'tpu for mjf' || this.materials.items[i].Title.toLowerCase() === 'tpu ultrasint') {
              link = 'https://www.elmec.com/3d/risorse/documenti/materiali/TDS_Ultrasint_TPU01.pdf'
            }
            break
          }
        }

        return link
      },
      getPostProcessLinkFromCode: function () {
        let link = ''

        for (let i = 0; i < this.postProcesses.items.length; i++) {
          if (this.postProcesses.items[i].ID === this.postProcesses.selected.toString()) {
            link = this.postProcesses.items[i].LinkDetail
            break
          }
        }

        return link
      }
    }
  }
</script>

<style lang="less">
  @import "~vue-elmec-style/less/variabili.less";

  #configuratore {
    width: 100%;
    height: 480px;
    margin-bottom: 50px;
    // FIX VIEWER
    .loader-mask-config {
      opacity: 0.5;
      // TEST
      position: relative;
      height: 100%;
      // END TEST
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      z-index: 99999;

      &.loader-render-model {
        position: absolute;
      }

      .loader-config {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 50px;
        height: 50px;
        font-size: 0;
        color: #4285F4;
        display: inline-block;
        margin: -25px 0 0 -25px;
        text-indent: -9999em;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);

        div {
          background-color: #4285F4;
          display: inline-block;
          float: none;
          position: absolute;
          top: 0;
          left: 0;
          width: 50px;
          height: 50px;
          opacity: .5;
          border-radius: 50%;
          -webkit-animation: ballPulseDouble 2s ease-in-out infinite;
          animation: ballPulseDouble 2s ease-in-out infinite;

          &div:last-child {
            -webkit-animation-delay: -1s;
            animation-delay: -1s;
          }
        }
      }

      .percentage-upload {
        text-align: center;
        font-size: 30px;
        position: absolute;
        top: 30%;
        width: 100%;
      }
    }

    #container-selector-file {
      position: relative;

      .uploader {
        height: 480px;
        margin-bottom: 50px;
        background-color: #fff;
        box-sizing: border-box;

        .uploader-action {
          margin-top: 100px;
          padding: 20px;
          background: #fff;
          cursor: pointer;
          height: 250px;

          .dz-message {
            &.noselect {
              -webkit-touch-callout: none; /* iOS Safari */
              -webkit-user-select: none; /* Safari */
              -khtml-user-select: none; /* Konqueror HTML */
              -moz-user-select: none; /* Firefox */
              -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none;
              /* Non-prefixed version, currently
                                               supported by Chrome and Opera */
            }

            color: #fff;
            height: 100%;
            width: 100%;
            display: table;
            border: 3px dashed #adadad;
            border-radius: 4px;
            font-size: 16px;
            text-align: center;

            h2, h3 {
              margin-top: 50px;
              color: #adadad;
            }

            .label-upload {
              display: table-cell;
              vertical-align: middle;
            }

            &.loading {
              /*position: absolute;*/
              // TEST
              position: relative;
              // END TEST
              left: 50%;
              top: 50%;
              width: 50px;
              height: 50px;
              font-size: 0;
              color: #4285F4;
              display: inline-block;
              margin: -25px 0 0 -25px;
              text-indent: -9999em;
              -webkit-transform: translateZ(0);
              -ms-transform: translateZ(0);
              transform: translateZ(0);

              div {
                background-color: #4285F4;
                display: inline-block;
                float: none;
                position: absolute;
                top: 0;
                left: 0;
                width: 50px;
                height: 50px;
                opacity: .5;
                border-radius: 50%;
                -webkit-animation: ballPulseDouble 2s ease-in-out infinite;
                animation: ballPulseDouble 2s ease-in-out infinite;

                &div:last-child {
                  -webkit-animation-delay: -1s;
                  animation-delay: -1s;
                }
              }
            }
          }
        }
      }
    }

    #upload-completed {
      margin-bottom: 20px;
      text-align: center;
      text-transform: uppercase;
    }

    #container-config-file {
      height: 100%;
      margin-bottom: 50px;
      float: left;
      position: relative;

      #viewer {
        height: 100%;
      }

      .percentage-stl-component {
        position: absolute;
        height: 100%;
        padding-top: 120px;
        text-align: center;
        font-size: 30px;
        color: #626366;
        width: 100%;
      }

      #option-menu {
        height: 100%;
        padding: 15px 25px;
        box-shadow: 0 0 25px -8px #cdcdcd;
        border-radius: 10px;

        select {
          margin: 0;
          padding-left: 3px;
          padding-right: 30px;
          background-color: transparent;
          border-bottom: 1px solid #fbbc05;
          height: 33px;
          float: left;

          option {
            color: #fff;
            background-color: #fbbc05;
            border: none;
          }
        }

        input {
          margin: 0;
          padding-left: 3px;
          padding-right: 30px;
          background-color: transparent;
          border-bottom: 1px solid #fbbc05;
          height: 33px;
          float: left;

          &:focus {
            border: none;
            border-bottom: 1px solid #fbbc05;
          }
        }

        .item-to-select {
          padding-top: 5px;

          .text-item-to-select {
            float: left;
            height: 30px;
            text-align: left;
            padding: 0;
            color: #4285f4;

            .filters-label {
              float: left;
              height: 30px;
              text-align: left;
              padding: 0;
              padding-top: 6px;
              color: #4285f4;
            }

            .dettaglio {
              display: block;
              height: 33px;
              float: right;
              width: auto;
              padding-top: 10px;
              padding-right: 7px;
            }
          }

          .file-name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .text-row {
            input {
              width: 100%;
            }
          }
        }

        #loader-detail-prd {
          height: 195px;
        }

        #container-detail-prd {
          display: inline-block;
          float: left;
          padding-top: 6px;
        }
      }
    }

    .warning-enabled {
      margin-top: 25px;

      #box-warning {
        font-size: 13px;
        color: #f7bc33;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    .button-blu-effect {
      height: 44px;
      background-color: #4285F4;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 190px;
      padding: 0;

      &:hover {
        background-color: #004B96;
        border: none;
        border-radius: 15px;
      }
    }

    .button-yellow-effect {
      height: 44px;
      background-color: #f7bc33;
      border-radius: 15px;
      color: white;
      font-weight: bold;
      width: 100px;
      padding: 0;
      text-transform: uppercase;
      float: right;

      &:hover {
        background-color: #cd9401;
        border: none;
      }
    }

    .icona-warning {
      font-size: 25px;
      color: #f7bc33;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ConfiguratoreNew.vue